import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { Onp1linkComponent } from './onp1link/onp1link.component';
import { Onp2linkComponent } from './onp2link/onp2link.component';
import { Onp3linkComponent } from './onp3link/onp3link.component';
import { Onp4linkComponent } from './onp4link/onp4link.component';
import { Onp5linkComponent } from './onp5link/onp5link.component';
import { Onp6linkComponent } from './onp6link/onp6link.component';
import { Onp7linkComponent } from './onp7link/onp7link.component';
import { Onp8linkComponent } from './onp8link/onp8link.component';
import { Onp9linkComponent } from './onp9link/onp9link.component';
import { Onp10linkComponent } from './onp10link/onp10link.component';
import { Onp11linkComponent } from './onp11link/onp11link.component';
import { Onp12linkComponent } from './onp12link/onp12link.component';
import { Onp13linkComponent } from './onp13link/onp13link.component';
import { Onp14linkComponent } from './onp14link/onp14link.component';
import { Onp15linkComponent } from './onp15link/onp15link.component';
import { Onp16linkComponent } from './onp16link/onp16link.component';
import { Onp17linkComponent } from './onp17link/onp17link.component';
import { Onp18linkComponent } from './onp18link/onp18link.component';
import { Onp19linkComponent } from './onp19link/onp19link.component';
import { Onp20linkComponent } from './onp20link/onp20link.component';
import { Onp21linkComponent } from './onp21link/onp21link.component';
import { Onp22linkComponent } from './onp22link/onp22link.component';
import { Onp23linkComponent } from './onp23link/onp23link.component';
import { Onp24linkComponent } from './onp24link/onp24link.component';
import { Onp25linkComponent } from './onp25link/onp25link.component';
import { Onp26linkComponent } from './onp26link/onp26link.component';
import { Onp27linkComponent } from './onp27link/onp27link.component';
import { Onp28linkComponent } from './onp28link/onp28link.component';
import { Onp29linkComponent } from './onp29link/onp29link.component';
import { Onp30linkComponent } from './onp30link/onp30link.component';
import { Onp31linkComponent } from './onp31link/onp31link.component';
import { Onp32linkComponent } from './onp32link/onp32link.component';
import { Onp33linkComponent } from './onp33link/onp33link.component';
import { Onp34linkComponent } from './onp34link/onp34link.component';
import { Onp35linkComponent } from './onp35link/onp35link.component';
import { Onp36linkComponent } from './onp36link/onp36link.component';
import { Onp37linkComponent } from './onp37link/onp37link.component';
import { Onp38linkComponent } from './onp38link/onp38link.component';
import { Onp40linkComponent } from './onp40link/onp40link.component';
import { Onp41linkComponent } from './onp41link/onp41link.component';
import { Onp42linkComponent } from './onp42link/onp42link.component';
import { Onp43linkComponent } from './onp43link/onp43link.component';
import { Onp44linkComponent } from './onp44link/onp44link.component';
import { Onp45linkComponent } from './onp45link/onp45link.component';
import { Onp46linkComponent } from './onp46link/onp46link.component';
import { Onp47linkComponent } from './onp47link/onp47link.component';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { OwlModule } from 'ngx-owl-carousel';
import { Onp48linkComponent } from './onp48link/onp48link.component';
import { Onp39linkComponent } from './onp39link/onp39link.component';
import { ReferralIdResolver } from 'src/app/shared/resolvers/referral-id.resolver';
import { MatSliderModule } from "@angular/material/slider";
const routes: Routes = [
  {
    path: '',
    resolve: { sponsorData: ReferralIdResolver },
    children: [
      { path: 'op1', component: Onp1linkComponent },
      { path: 'op2', component: Onp2linkComponent },
      { path: 'op3', component: Onp3linkComponent },
      { path: 'op4', component: Onp4linkComponent },
      { path: 'op5', component: Onp5linkComponent },
      { path: 'op6', component: Onp6linkComponent },
      { path: 'op7', component: Onp7linkComponent },
      { path: 'op8', component: Onp8linkComponent },
      { path: 'op9', component: Onp9linkComponent },
      { path: 'op10', component: Onp10linkComponent },
      { path: 'op11', component: Onp11linkComponent },
      { path: 'op12', component: Onp12linkComponent },
      { path: 'op13', component: Onp13linkComponent },
      { path: 'op14', component: Onp14linkComponent },
      { path: 'op15', component: Onp15linkComponent },
      { path: 'op16', component: Onp16linkComponent },
      { path: 'op17', component: Onp17linkComponent },
      { path: 'op18', component: Onp18linkComponent },
      { path: 'op19', component: Onp19linkComponent },
      { path: 'op20', component: Onp20linkComponent },
      { path: 'op21', component: Onp21linkComponent },
      { path: 'op22', component: Onp22linkComponent },
      { path: 'op23', component: Onp23linkComponent },
      { path: 'op24', component: Onp24linkComponent },
      { path: 'op25', component: Onp25linkComponent },
      { path: 'op26', component: Onp26linkComponent },
      { path: 'op27', component: Onp27linkComponent },
      { path: 'op28', component: Onp28linkComponent },
      { path: 'op29', component: Onp29linkComponent },
      { path: 'op30', component: Onp30linkComponent },
      { path: 'op31', component: Onp31linkComponent },
      { path: 'op32', component: Onp32linkComponent },
      { path: 'op33', component: Onp33linkComponent },
      { path: 'op34', component: Onp34linkComponent },
      { path: 'op35', component: Onp35linkComponent },
      { path: 'op36', component: Onp36linkComponent },
      { path: 'op37', component: Onp37linkComponent },
      { path: 'op38', component: Onp38linkComponent },
      { path: 'op39', component: Onp39linkComponent },
      { path: 'op40', component: Onp40linkComponent },
      { path: 'op41', component: Onp41linkComponent },
      { path: 'op42', component: Onp42linkComponent },
      { path: 'op43', component: Onp43linkComponent },
      { path: 'op44', component: Onp44linkComponent },
      { path: 'op45', component: Onp45linkComponent },
      { path: 'op46', component: Onp46linkComponent },
      { path: 'op47', component: Onp47linkComponent },
      { path: 'op48', component: Onp48linkComponent },
    ],
  },
];

@NgModule({
  declarations: [
    Onp1linkComponent,
    Onp2linkComponent,
    Onp3linkComponent,
    Onp4linkComponent,
    Onp5linkComponent,
    Onp6linkComponent,
    Onp7linkComponent,
    Onp8linkComponent,
    Onp9linkComponent,
    Onp10linkComponent,
    Onp11linkComponent,
    Onp12linkComponent,
    Onp13linkComponent,
    Onp15linkComponent,
    Onp16linkComponent,
    Onp17linkComponent,
    Onp18linkComponent,
    Onp19linkComponent,
    Onp20linkComponent,
    Onp21linkComponent,
    Onp22linkComponent,
    Onp23linkComponent,
    Onp24linkComponent,
    Onp25linkComponent,
    Onp26linkComponent,
    Onp27linkComponent,
    Onp28linkComponent,
    Onp29linkComponent,
    Onp30linkComponent,
    Onp31linkComponent,
    Onp32linkComponent,
    Onp33linkComponent,
    Onp34linkComponent,
    Onp35linkComponent,
    Onp36linkComponent,
    Onp37linkComponent,
    Onp38linkComponent,
    Onp39linkComponent,
    Onp40linkComponent,
    Onp41linkComponent,
    Onp42linkComponent,
    Onp43linkComponent,
    Onp44linkComponent,
    Onp45linkComponent,
    Onp46linkComponent,
    Onp47linkComponent,
    Onp48linkComponent,
  ],
  imports: [
    CommonModule,
    MatSliderModule,
    RouterModule.forChild(routes),
    NgbCarouselModule,
    CarouselModule,
    OwlModule,
  ],
})
export class OnpassivelinkModule {}
